module.exports = {"652827100":"和静镇","652827101":"巴伦台镇","652827102":"巴润哈尔莫敦镇","652827103":"哈尔莫敦镇","652827104":"巴音布鲁克镇","652827105":"巩乃斯镇","652827106":"乃门莫敦镇","652827107":"协比乃尔布呼镇","652827203":"克尔古提乡","652827204":"阿拉沟乡","652827205":"额勒再特乌鲁乡","652827206":"巴音郭楞乡","652827400":"乌拉斯台农场","652827501":"兵团二十一团","652827502":"兵团二十二团","652827503":"兵团二二三团","652827504":"兵团农二师湖光糖厂"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652827.json
// module id = 3088
// module chunks = 0